<div class="o-grid--medium">
  <div class="o-grid__item col-12 u-b-divider--dark"></div>
  <div class="o-grid__item col-9 u-mt--medium">
    <div class="c-item-title">{{ subscription.title | translate }}</div>
  </div>
  <div class="o-grid__item col-3 u-mt--medium">
    <input
      type="checkbox"
      [name]="subscription.name + 'Slider'"
      [id]="subscription.name + 'Slider'"
      class="c-checkbox-slider--sm"
      [(ngModel)]="subscription.isActive" />
    <label
      [for]="subscription.name + 'Slider'"
      class="c-switch-slider--sm"></label>
  </div>
  <div
    *ngIf="subscription.isActive"
    class="c-form-group o-grid__item col-5">
    <label
      for="activeFrom"
      class="c-form-label"
      >{{ "subscription.activefrom" | translate }}</label
    >
    <div
      class="c-input-group"
      *ngIf="subscription.isEditing">
      <datepicker-input
        [inputDate]="subscription.activeFrom"
        size="md"
        (dateChange)="activeFrom = $event">
      </datepicker-input>
    </div>
    <div
      class="u-line-height-34 u-text-left"
      *ngIf="!subscription.isEditing">
      {{ subscription.activeFrom | date }}
    </div>
  </div>
  <div
    *ngIf="subscription.isActive"
    class="c-form-group o-grid__item col-5">
    <label
      for="activeTo"
      class="c-form-label"
      >{{ "subscription.activeto" | translate }}</label
    >
    <div
      class="c-input-group"
      *ngIf="subscription.isEditing">
      <datepicker-input
        [inputDate]="subscription.activeTo"
        size="md"
        (dateChange)="activeTo = $event">
      </datepicker-input>
    </div>
    <div
      class="u-line-height-34 u-text-left"
      *ngIf="!subscription.isEditing">
      {{ subscription.activeTo | date }}
    </div>
  </div>
  <div
    *ngIf="subscription.isActive"
    class="o-grid__item col-2">
    <label class="c-form-label">&nbsp;</label>
    <button
      *ngIf="!subscription.isEditing"
      (click)="subscription.isEditing = !subscription.isEditing"
      type="button"
      class="button--sm button-secondary button-block">
      {{ "button.edit" | translate }}
    </button>
    <button
      *ngIf="subscription.isEditing"
      type="button"
      (click)="onSubmit()"
      class="button--sm button-primary button-block">
      {{ "button.save" | translate }}
    </button>
  </div>
</div>
